<template>
  <div class="goalManage">
    <PageNav :slider="slider" :openMenu="openMenu">
      <el-main>
        <div id="page-goalManage">
          <div class="head-tab--nav">
            <div class="head-nav h-3">
              <span class="c-normal clearFloat">{{ $t("Goalmanage.be") }}</span>
              <div class="pull-right">
                <el-button @click="handleCreateClick()" type="warning">{{
                  $t("Goalmanage.bf")
                }}</el-button>
                <el-button type="primary" @click="daochu">{{
                  $t("Common.btn_export")
                }}</el-button>
              </div>
            </div>
          </div>
          <div class="goalManage-container">
            <div class="content">
              <div class="content-nav--head text-1">
                <!-- <div class="c-n--head_rt">
                  <span class="mr10">招生目标管理</span>
                </div>-->
                <div class="c-n--head_lf">
                  <div class="time head-right">
                    <el-date-picker
                      type="date"
                      :placeholder="$t('Goalmanage.ac')"
                      v-model="selectForm.goal_starttime"
                      value-format="yyyy-MM-dd"
                      @change="handleSelect()"
                      style="width: 140px"
                    ></el-date-picker>
                    <span>{{ $t("Goalmanage.ad") }}</span>
                    <el-date-picker
                      type="date"
                      :placeholder="$t('Goalmanage.ae')"
                      v-model="selectForm.goal_endtime"
                      style="width: 140px"
                      value-format="yyyy-MM-dd"
                      @change="handleSelect()"
                    ></el-date-picker>
                  </div>
                  <label class="state-label">{{ $t("Goalmanage.af") }}</label>
                  <el-select
                    filterable
                    v-model="selectForm.found_marketer_id"
                    class="mr15"
                    style="width: 150px"
                    clearable
                    :placeholder="$t('Goalmanage.ag')"
                    @change="handleSelect()"
                  >
                    <el-option
                      v-for="item in founder"
                      :key="item.marketer_id"
                      :label="`${item.marketer_name} ${
                        item.staffer_enname
                          ? '(' + item.staffer_enname + ')'
                          : ''
                      }`"
                      :value="item.marketer_id"
                    ></el-option>
                  </el-select>
                  <el-input
                    clearable
                    :placeholder="$t('Goalmanage.bg')"
                    class="input-cont"
                    style="width: 200px"
                    v-model="selectForm.keyword"
                    @change="handleSelectKeyword()"
                  ></el-input>
                  <el-button
                    type="primary"
                    class="btn-inquire"
                    @click="handleSelectKeyword()"
                    >{{ $t("Goalmanage.ai") }}</el-button
                  >
                </div>
              </div>
              <TableList
                :list="tableData"
                :options="optionscaozuo"
                :columns="columns"
                :isPagination="isPagination"
                :operates="operates"
                :total="dataNumber"
                @handleColumnChange="handleColumnChange"
              ></TableList>
              <el-pagination
                style="margin-top: 35px"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="currentPage"
                :page-sizes="[10, 20, 30, 40]"
                :page-size="pagesize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="dataNumber"
              ></el-pagination>
            </div>
          </div>
        </div>
      </el-main>
    </PageNav>

    <!-- 侧边新建栏 -->
    <!-- 侧边栏 -->
    <SliderBox
      :showSliderBox="showSliderBoxCreate"
      @hideSliderBox="hideSliderBoxCreate"
      :sliderWidth="sliderWidth"
    >
      <aimsCreate
        :showUserSliderBox="showSliderBoxCreate"
        :settingStaff="settingStaff"
        @onSubmit="onSubmit"
        @hideSliderBoxCreate="hideSliderBoxCreate"
      ></aimsCreate>
    </SliderBox>

    <!-- 侧边编辑栏 -->
    <SliderBox
      :showSliderBox="showSliderBoxEdit"
      @hideSliderBox="hideSliderBoxEdit"
      :sliderWidth="sliderWidth"
    >
      <aimsEdit
        :showUserSliderBox="showSliderBoxEdit"
        :settingStaff="settingStaff"
        :basicinformation="basicinformation"
        :joinlist="joinlist"
        @editSubmit="editSubmit"
        @hideSliderBoxEdit="hideSliderBoxEdit"
      ></aimsEdit>
    </SliderBox>

    <!-- 侧边查看栏 -->
    <!-- 侧边栏 -->
    <SliderBox
      :showSliderBox="showSliderBoxSee"
      @hideSliderBox="hideSliderBoxSee"
      :sliderWidth="sliderWidth"
    >
      <div class="silder-contain slider-goalManage silder-contain-seeing">
        <div class="slider-top clearFloat">
          <p class="h3 slider-title pull-left">{{ $t("Goalmanage.bh") }}</p>
          <div
            class="pull-right h1 btn-close font-gray"
            @click="hideSliderBoxSee"
          >
            <i class="el-icon-close"></i>
          </div>
          <el-button type="primary" class="pull-right" @click="handClickEdit">{{
            $t("Goalmanage.al")
          }}</el-button>
        </div>
        <div class="slider-cont text-1">
          <el-tabs v-model="activeName1" @tab-click="handleSliderSeeClick">
            <el-tab-pane :label="$t('Goalmanage.bi')" name="first">
              <p class="form-small-title h3">{{ $t("Goalmanage.bj") }}</p>
              <div class="base-info text-1">
                <p>
                  <span class="label font-55606E">{{
                    $t("Goalmanage.bk")
                  }}</span>
                  <span class="label-cont">{{
                    basicinformation.goal_name
                  }}</span>
                </p>
                <p>
                  <span class="label font-55606E">{{
                    $t("Goalmanage.bl")
                  }}</span>
                  <span class="label-cont">{{
                    basicinformation.goal_starttime
                  }}</span>
                </p>
                <p>
                  <span class="label font-55606E">{{
                    $t("Goalmanage.bm")
                  }}</span>
                  <span class="label-cont">{{
                    basicinformation.goal_endtime
                  }}</span>
                </p>
                <p>
                  <span class="label font-55606E">{{
                    $t("Goalmanage.bn")
                  }}</span>
                  <span class="label-cont"
                    >{{ basicinformation.goal_mintrack }}({{
                      $t("Goalmanage.bo")
                    }})</span
                  >
                  <span
                    >{{ basicinformation.goal_normtrack }}({{
                      $t("Goalmanage.bp")
                    }})</span
                  >
                </p>
                <p>
                  <span class="label font-55606E">{{
                    $t("Goalmanage.bq")
                  }}</span>
                  <span class="label-cont"
                    >{{ basicinformation.goal_mininvite }}({{
                      $t("Goalmanage.bo")
                    }})</span
                  >
                  <span
                    >{{ basicinformation.goal_norminvite }}({{
                      $t("Goalmanage.bp")
                    }})</span
                  >
                </p>
                <p>
                  <span class="label font-55606E">{{
                    $t("Goalmanage.br")
                  }}</span>
                  <span class="label-cont"
                    >{{ basicinformation.goal_minofficial }}({{
                      $t("Goalmanage.bo")
                    }})</span
                  >
                  <span
                    >{{ basicinformation.goal_normofficial }}({{
                      $t("Goalmanage.bp")
                    }})</span
                  >
                </p>
                <p>
                  <span class="label font-55606E">{{
                    $t("Goalmanage.bs")
                  }}</span>
                  <span class="label-cont">{{
                    basicinformation.goal_maxtracknumber
                  }}</span>
                </p>
              </div>
              <!-- <div class="line"></div> -->
              <p class="form-small-title h3">{{ $t("Goalmanage.bt") }}</p>
              <div class="setting">
                <el-row>
                  <el-col :span="3">
                    <div class="clearFloat h-3">{{ $t("Goalmanage.bu") }}</div>
                  </el-col>
                  <el-col :span="21">
                    <ul class="joinlist">
                      <li v-for="(item, index) in joinlist" :key="index">
                        <!-- <input class="li-checkbox" type="checkbox"> -->
                        <label>
                          {{ item.name }}
                          <i
                            :class="{
                              'crmIcon-nv': item.sex == $t('Common.woman'),
                              'crmIcon-nan': item.sex != $t('Common.woman'),
                            }"
                          ></i>
                        </label>
                      </li>
                    </ul>
                  </el-col>
                </el-row>
              </div>
              <!-- <div class="bottom-btn" style="margin-left:20px">
                <el-button type="primary" @click="onSubmit">确认</el-button>
                <el-button @click="hideSliderBox()">取消</el-button>
              </div>-->
            </el-tab-pane>
            <el-tab-pane label="目标完成状况" name="second">
              <div class="completion-status">
                <p class="form-small-title h3">{{ $t("Goalmanage.by") }}</p>
                <div class="select-row select-row1">
                  <span
                    style="width: 90px; display: inline-block"
                    class="font-55606E"
                    >{{ $t("Goalmanage.bz") }}</span
                  >
                  <el-select
                    filterable
                    v-model="valuedimension"
                    :placeholder="$t('Goalmanage.ca')"
                    class="select-dimension"
                    style="width: 300px"
                    @change="handClickdimension()"
                  >
                    <el-option
                      v-for="item in dimensionData"
                      :key="item.marketer_id"
                      :label="item.marketer_name"
                      :value="item.marketer_id"
                    ></el-option>
                  </el-select>
                  <div class="echart clearFloat">
                    <div
                      id="see-completion-echart"
                      class="pull-left"
                      :style="{ width: '300px', height: '300px' }"
                    ></div>
                    <div
                      id="see-completion-echart-right"
                      class="pull-right"
                      :style="{ width: '300px', height: '300px' }"
                    ></div>
                  </div>
                </div>
                <p class="form-small-title h3">{{ $t("Goalmanage.cb") }}</p>
                <div class="select-row select-row2">
                  <div
                    id="see-rate-echart"
                    :style="{ width: '450px', height: '300px' }"
                  ></div>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </SliderBox>

    <!-- 删除 -->
    <el-dialog
      title="删除目标"
      :visible.sync="DelVisible"
      width="30%"
      :before-close="handleClose"
    >
      <div class="del-box">
        <div class="delTips tc">{{ $t("Goalmanage.cd") }}</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="DelVisible = false">{{
          $t("Goalmanage.ao")
        }}</el-button>
        <el-button type="primary" @click="handleDelClickConfim()">{{
          $t("Goalmanage.ap")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import PageNav from "../../components/Nav/nav.vue";
import echarts from "echarts";
import SliderBox from "../../components/SliderBox";
import TableList from "../../components/Table/table.vue";
import storeGoalmanage from "../Goalmanage/Goalmanage.js";
import aimsCreate from "../../components/Aims/create.vue";
import aimsEdit from "../../components/Aims/edit.vue";
export default {
  name: "Goalmanage-goalManage",
  data() {
    return {
      openMenu: ["1"],
      isPagination: true,
      showSliderBoxCreate: false,
      showSliderBoxSee: false,
      showSliderBoxEdit: false,
      DelVisible: false, //删除
      fullscreenLoading: true, //全屏loading
      // 分页的数据
      dataNumber: 0, //数据总数
      currentPage: 1,
      pagenum: "1",
      pagesize: 10,
      basicinformation: [],
      dialogVisible: false,
      input: "",
      select: "",
      sliderWidth: "700px",
      activeName: "first",
      activeName1: "first",
      //条形图转正人次
      positiveNameList: [],
      positiveValueList: [],
      goalId: "", //暂存单个目标ID
      //筛选条件
      selectForm: {
        goal_starttime: "",
        goal_endtime: "",
        found_marketer_id: "",
        keyword: "",
      },
      //创建人
      founder: [],
      // 环形图数据
      trackRate: [],
      inviteRate: [],
      //参与目标的考核员工数据
      StaffNum: "0",
      StaffEditNum: "0",
      settingStaff: [],
      // 侧边栏 资料建档
      form: {
        goal_name: "",
        goal_starttime: "",
        goal_endtime: "",
        goal_mintrack: "",
        goal_normtrack: "",
        goal_norminvite: "",
        goal_mininvite: "",
        goal_normofficial: "",
        goal_minofficial: "",
        checkMarketer: [],
      },
      editForm: {
        goal_name: "",
        goal_starttime: "",
        goal_endtime: "",
        goal_mintrack: "",
        goal_normtrack: "",
        goal_norminvite: "",
        goal_mininvite: "",
        goal_normofficial: "",
        goal_minofficial: "",
        checkMarketer: [],
      },
      // 男女图标
      iconWommen: require("../../assets/images/icon/icon-person-women.png"),
      iconmen: require("../../assets/images/icon/icon-person-men.png"),
      options: [
        {
          value: "选项1",
          label: "黄金糕",
        },
        {
          value: "选项2",
          label: "双皮奶",
        },
      ],
      valuedimension: "",
      dimensionData: [], //参与目标的员工
      // //存储招生目标表格数据
      tableData: [],
      columnWidth: ["200", "200", "150", "150", "250", "250", "250", "250"], //表格宽度
      optionscaozuo: {
        mutiSelect: false, // 是否支持列表项选中功能
        loading: true, //数据loading
        highlightCurrentRow: true, // 是否支持当前行高亮显示
        tableHeight: Number, //表格高度
        errortip: "",
      },
      columns: [], //存储招生目标表格的列
      operates: {
        width: 150,
        label: this.$t("Goalmanage.ce"),
        align: "center",
        fixed: "right",
        list: [
          {
            id: "1",
            label: this.$t("Goalmanage.cf"),
            type: "text",
            show: true,
            plain: true,
            disabled: false,
            method: (index, row) => {
              this.handleClick(row);
            },
          },
          {
            id: "2",
            label: this.$t("Goalmanage.cg"),
            type: "text",
            show: true,
            plain: true,
            disabled: false,
            method: (index, row) => {
              this.DelVisible = true;
              this.goalId = row.goal_id;
            },
          },
        ],
      }, // 列操作按钮
      joinlist: [],
      defaultProps: {
        children: "children",
        label: "label",
      },
    };
  },
  components: {
    PageNav,
    SliderBox,
    aimsCreate,
    aimsEdit,
    TableList,
  },
  updated() {
    this.fullscreenLoading = false;
  },
  created() {
    
    this.slider = this.$store.state.Slider;
    this.token = this.$store.state.USER_TOKEN;
    this.marketer_id = this.$store.state.MARKETER_ID;
    this.school_id = this.$store.state.SCHOOL_ID;
    this.company_id = this.$store.state.COMPANY_ID;
    this.postbe_crmuserlevel = this.$Tool.getStorage("PostbeCrmlevel")
      ? this.$Tool.getStorage("PostbeCrmlevel")
      : "";
    this.re_postbe_id = this.$Tool.getStorage("re_postbe_id")
      ? this.$Tool.getStorage("re_postbe_id")
      : "";
    this.language_type = this.$Tool.getStorage("language")
      ? this.$Tool.getStorage("language")
      : "";
    // this.school_id = this.$Tool.getStorage("school_id");
    this.getSellgoalData(this.pagenum);
    this.getgoalFounderData(); // 获取目标创建人管理
    this.optionscaozuo.tableHeight = this.$Common.getTableHeight(310); //设置表格高度
  },
  mounted() {},
  methods: {
    // 招生目标管理
    getSellgoalData(page) {
      storeGoalmanage
        .getSellgoal({
          marketer_id: this.marketer_id,
          token: this.token,
          school_id: this.school_id,
          company_id: this.company_id,
          is_count: "1", //是否需要总数，可以不传
          p: this.currentPage,
          num: this.pagesize,
          goal_starttime: this.selectForm.goal_starttime,
          goal_endtime: this.selectForm.goal_endtime,
          found_marketer_id: this.selectForm.found_marketer_id,
          keyword: this.selectForm.keyword,
        })
        .then((res) => {
          const { code, msg, data } = res.data;
          this.tableData = data.list || [];
          this.dataNumber = data.allnum;
         
          var Columns = data.field;
          this.columns = this.$Common.handleTable(
            Columns,
            this.columnWidth,
            true,
            0
          );
          this.optionscaozuo.loading = false;
          if (code !== 200) {
            this.optionscaozuo.errortip = msg;
          }
        });
    },
    // 选择查询
    handleSelect() {
      this.currentPage = 1;
      this.getSellgoalData(this.pagenum);
    },
    // 输入关键词查询
    handleSelectKeyword() {
      this.currentPage = 1;
      this.getSellgoalData(this.pagenum);
    },
    // 统计维度筛选跟踪柜询完成率
    handClickdimension() {
      this.getgoalFinishRateData(this.goalId);
    },
    // 获取目标创建人管理
    getgoalFounderData() {
      storeGoalmanage
        .getgoalFounder({
          marketer_id: this.marketer_id,
          token: this.token,
          school_id: this.school_id,
          company_id: this.company_id,
        })
        .then((res) => {
          // 
          this.founder = res.data.data.data;
        });
    },
    // 单个招生目标查看
    getgoalOneData(id) {
      storeGoalmanage
        .getgoalOne({
          marketer_id: this.marketer_id,
          token: this.token,
          school_id: this.school_id,
          company_id: this.company_id,
          goal_id: id, //目标 id
        })
        .then((res) => {
          
          this.basicinformation = res.data.data.data;
          // this.dimensionData=res.data.data.data.participant.split(",");
          var participant = res.data.data.data.participant.split(","); //职工姓名
          var participantid = res.data.data.data.participantid.split(","); //职工id
          if (res.data.data.data.participantsex != null) {
            var participantsex = res.data.data.data.participantsex.split(","); //职工性别
          }
          if (participant != "") {
            var arr = [];
            participant.forEach((item, index) => {
              let obj = {};
              obj.name = item;
              obj.id = participantid[index];
              obj.sex = participantsex[index];
              arr.push(obj);
            });
            this.joinlist = arr;
          }
          this.getgoalCheckMarketerData(); //参与目标的所有考核员工
        });
    },
    // 某目标参与成员的线索转正数
    getgoalFinishStatusData(id) {
      storeGoalmanage
        .getgoalFinishStatus({
          marketer_id: this.marketer_id,
          token: this.token,
          school_id: this.school_id,
          company_id: this.company_id,
          goal_id: id, //目标 id
        })
        .then((res) => {
          (() => {})(res.data.data.data, this.positiveNameList);
          this.positiveNameList = [];
          this.positiveValueList = []; //初始化数据
          if (res.data.data.data.length != 0) {
            res.data.data.data.forEach((item) => {
              this.positiveNameList.push(item.marketer_name);
              this.positiveValueList.push(item.conversionnum);
            });
          } else {
            this.positiveNameList = [];
            this.positiveValueList = [];
          }

          let timer = setTimeout(() => {
            this.canvasWidth();
            this.comparedDrawLine();
            this.ColumnarDrawLine();
            clearTimeout(timer);
          }, 20);
          //  (() => {})( this.positiveNameList)
          //   (() => {})( this.positiveValueList)
        });
    },
    // 某目标参与成员的跟踪柜询完成率
    getgoalFinishRateData(id) {
      storeGoalmanage
        .getgoalFinishRate({
          marketer_id: this.marketer_id,
          token: this.token,
          school_id: this.school_id,
          company_id: this.company_id,
          goal_id: id, //目标 id
          from_marketer_id: this.valuedimension, //跟踪人的 id
        })
        .then((res) => {
          // 
          // 数据初始化
          this.trackRate = [];
          this.inviteRate = [];
          if (res.data.data.data != null) {
            // res.data.data.data.forEach(item => {
            //   this.trackRate.push(item.tracknum);
            //   this.trackRate.push(item.nottracknum);
            //   this.inviteRate.push(item.invitenum);
            //   this.inviteRate.push(item.notinvitenum);
            // });
            this.trackRate.push(res.data.data.data.tracknum);
            this.trackRate.push(res.data.data.data.nottracknum);
            this.inviteRate.push(res.data.data.data.invitenum);
            this.inviteRate.push(res.data.data.data.notinvitenum);
          } else {
            this.trackRate = [];
            this.inviteRate = [];
          }

          let timer = setTimeout(() => {
            this.canvasWidth();
            this.comparedDrawLine();
            this.ColumnarDrawLine();
            clearTimeout(timer);
          }, 20);
        });
    },
    // 参与目标考核的所有员工
    getgoalCheckMarketerData() {
      storeGoalmanage
        .getgoalCheckMarketer({
          marketer_id: this.marketer_id,
          token: this.token,
          school_id: this.school_id,
          company_id: this.company_id, //所属集团
        })
        .then((res) => {
          var marketer = res.data.data.data; //职工信息
          if (this.showSliderBoxSee) {
            // 查看时候
            var participantid = this.basicinformation.participantid.split(","); //职工id
            var arr = [];
            marketer.forEach((item, index) => {
              participantid.forEach((item2, index2) => {
                (() => {})(item2);
                if (item.marketer_id == item2) {
                  arr.push(item);
                }
              });
            });
            this.dimensionData = arr;
          } else {
            this.dimensionData = res.data.data.data;
          }
          
          if (marketer) {
            var arr = [];
            marketer.forEach((item) => {
              let obj = {};
              obj.name = item.marketer_name;
              obj.id = item.marketer_id;
              obj.sex = item.marketer_sex;
              arr.push(obj);
            });
            this.settingStaff = arr;
          }
        });
    },
    canvasWidth() {
      //canvas赋初始值
      let _canvaswidth =
        document.querySelector(".silder-contain").offsetWidth - 60;
      document.getElementById("see-completion-echart").style.width =
        _canvaswidth / 2 - 20 + "px";
      document.getElementById("see-completion-echart-right").style.width =
        _canvaswidth / 2 - 20 + "px";
      document.getElementById("see-rate-echart").style.width =
        _canvaswidth + "px";
    },
    // 环形图
    comparedDrawLine() {
      // 基于准备好的dom，初始化echarts实例
      let myChart = echarts.init(
        document.getElementById("see-completion-echart")
      );
      let myChart2 = echarts.init(
        document.getElementById("see-completion-echart-right")
      );
      let _this = this;
      (() => {})(this.inviteRate, 122333);
      (() => {})(_this.$t("Goalmanage.ch"));
      myChart.setOption({
        calculable: true,
        series: [
          {
            name: _this.$t("Goalmanage.ch"),
            type: "pie",
            radius: ["50%", "70%"],
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  position: "center",
                  // formatter: '{b}\n{c}'
                  formatter: function (param) {
                    (() => {})(_this.$t("Goalmanage.ch"));
                    if (param.name == _this.$t("Goalmanage.ch")) {
                      if (param.value == undefined) {
                        return "";
                      } else {
                        return param.name + "\n" + param.value + "%";
                      }
                    } else {
                      return "";
                    }
                  },
                },
              },
              emphasis: {
                label: {
                  show: true,
                  position: "center",
                  textStyle: {
                    fontSize: "30",
                    fontWeight: "bold",
                  },
                },
              },
            },
            data: [
              {
                value: this.trackRate[0],
                itemStyle: { color: "#20a8d8" },
                name: _this.$t("Goalmanage.ch"),
              },
              {
                value: this.trackRate[1],
                itemStyle: { color: "#f8cb00" },
                name: _this.$t("Goalmanage.ci"),
              },
            ],
          },
        ],
      });
      myChart2.setOption({
        calculable: true,
        series: [
          {
            name: this.$t("Goalmanage.cj"),
            type: "pie",
            radius: ["50%", "70%"],
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  position: "center",
                  // formatter: '{b}\n{c}'
                  formatter: function (param) {
                    if (param.name == _this.$t("Goalmanage.cj")) {
                      if (param.value == undefined) {
                        return "";
                      } else {
                        return param.name + "\n" + param.value + "%";
                      }
                    } else {
                      return "";
                    }
                  },
                },
              },
              emphasis: {
                label: {
                  show: true,
                  position: "center",
                  textStyle: {
                    fontSize: "30",
                    fontWeight: "bold",
                  },
                },
              },
            },
            data: [
              {
                value: this.inviteRate[0],
                itemStyle: { color: "#20a8d8" },
                name: this.$t("Goalmanage.cj"),
              },
              {
                value: this.inviteRate[1],
                itemStyle: { color: "#f8cb00" },
                name: this.$t("Goalmanage.ck"),
              },
            ],
          },
        ],
      });
    },
    // 条形图
    ColumnarDrawLine() {
      // 基于准备好的dom，初始化echarts实例
      let myChart = echarts.init(document.getElementById("see-rate-echart"));
      myChart.setOption({
        calculable: true,
        xAxis: [
          {
            grid: {
              left: "10%",
              bottom: "40%",
            },
            axisLabel: {
              rotate: -40,
            },
            type: "category",
            data: this.positiveNameList,
          },
        ],
        yAxis: [
          {
            type: "value",
            name: this.$t("Common.person"),
            min: 0,
            interval: 1, //间隔
            minInterval: 5, //设置成1保证坐标轴分割刻度显示成整数。
          },
        ],
        series: [
          {
            name: this.$t("Goalmanage.cm"),
            type: "bar",
            data: this.positiveValueList,
            color: "#5cc5f8",
            barGap: "0%",
            itemStyle: {
              normal: {
                label: {
                  show: true, //开启显示
                  position: "top", //在上方显示
                  textStyle: {
                    //数值样式
                    color: "#333",
                    fontSize: 12,
                  },
                },
              },
            },
          },
        ],
      });
    },
    // 点击名字查看单个员工
    handleColumnChange(k, v) {
      (() => {})(v, k);
      this.showSliderBoxSee = true;
      this.activeName1 = "first";
      (() => {})(v.goal_id);
      this.goalId = v.goal_id;
      this.getgoalOneData(v.goal_id);
      this.getgoalFinishStatusData(v.goal_id);
      this.getgoalFinishRateData(v.goal_id);
    },
    //选择职工
    handClickstaff() {
      this.StaffNum = this.form.checkMarketer.length;
    },
    handClickstaffedit() {
      this.StaffEditNum = this.editForm.checkMarketer.length;
    },
    hideSliderBoxCreate() {
      this.showSliderBoxCreate = false;
    },
    hideSliderBoxEdit() {
      this.showSliderBoxEdit = false;
    },
    hideSliderBoxSee() {
      this.showSliderBoxSee = false;
      this.valuedimension = ""; //数据清空 筛选条件
    },
    // 确定删除
    handleDelClickConfim() {
      // 删除招生目标
      storeGoalmanage
        .delGoal({
          marketer_id: this.marketer_id,
          token: this.token,
          school_id: this.school_id,
          company_id: this.company_id,
          goal_id: this.goalId,
        })
        .then((res) => {
          (() => {})(res);
          if (res.data.code === 200) {
            this.showSliderBoxEdit = false;
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.getSellgoalData(this.pagenum);
            this.DelVisible = false;
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        });
    },
    handleDel() {
      this.dialogVisible = true;
    },
    onSubmit(v) {
      // this.form.checkbox.splice(0,1);
      (() => {})(v);
      let data = v;
      data["marketer_id"] = this.marketer_id;
      data["token"] = this.token;
      data["school_id"] = this.school_id;
      data["company_id"] = this.company_id;
      var isnull =
        v.goal_name != "" &&
        v.goal_starttime != "" &&
        v.goal_endtime != "" &&
        v.goal_mintrack != "" &&
        v.goal_normtrack != "" &&
        v.goal_norminvite != "" &&
        v.goal_mininvite != "" &&
        v.goal_normofficial != "" &&
        v.goal_minofficial != "";
      if (isnull) {
        // 添加招生目标
        storeGoalmanage.addGoal(data).then((res) => {
          if (res.data.code === 200) {
            this.showSliderBoxCreate = false;
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.getSellgoalData(this.pagenum);
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        });
      } else {
        this.$message({
          message: this.$t("Goalmanage.cn"),
          type: "error",
        });
      }
    },
    editSubmit(v) {
      let data = v;
      (() => {})(data);
      data["marketer_id"] = this.marketer_id;
      data["token"] = this.token;
      data["goal_id"] = this.goalId;
      data["school_id"] = this.school_id;
      data["company_id"] = this.company_id;
      var isnull =
        v.goal_name != "" &&
        v.goal_starttime != "" &&
        v.goal_endtime != "" &&
        v.goal_mintrack != "" &&
        v.goal_normtrack != "" &&
        v.goal_norminvite != "" &&
        v.goal_mininvite != "" &&
        v.goal_normofficial != "" &&
        v.goal_minofficial != "";
      if (isnull) {
        // 修改招生目标
        storeGoalmanage.updateGoal(data).then((res) => {
          (() => {})(res);
          if (res.data.code === 200) {
            this.showSliderBoxEdit = false;
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.getSellgoalData(this.pagenum);
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        });
      } else {
        this.$message({
          message: this.$t("Goalmanage.cn"),
          type: "error",
        });
      }
    },
    changeSize() {
      (() => {})("change");
    },
    handleSliderClick(tab, event) {
      (() => {})(tab, event);
    },
    handClickEdit() {
      // this.settingStaff=this.joinlist;
      // this.StaffEditNum=this.joinlist.length;
      this.showSliderBoxEdit = true;
      this.showSliderBoxSee = false;
      (() => {})(this.settingStaff);
      // this.editForm={
      //   goal_name:this.basicinformation.goal_name,
      //   goal_starttime: this.basicinformation.goal_starttime,
      //   goal_endtime: this.basicinformation.goal_endtime,
      //   goal_mintrack: this.basicinformation.goal_mintrack,
      //   goal_normtrack: this.basicinformation.goal_normtrack,
      //   goal_norminvite: this.basicinformation.goal_norminvite,
      //   goal_mininvite: this.basicinformation.goal_mininvite,
      //   goal_normofficial: this.basicinformation.goal_normofficial,
      //   goal_minofficial: this.basicinformation.goal_minofficial,
      //   checkMarketer: []
      // };
      // this.getgoalCheckMarketerData();
    },
    handleSliderSeeClick(tab, event) {
      (() => {})(tab, event);
      this.valuedimension = ""; //数据清空 筛选条件
      this.getgoalFinishStatusData(this.goalId);
      this.getgoalFinishRateData(this.goalId);
    },
    handleClick(v) {
      this.showSliderBoxSee = true;
      this.activeName1 = "first";
      (() => {})(v.goal_id);
      this.goalId = v.goal_id;
      // this.getgoalCheckMarketerData();//参与目标的所有考核员工
      this.getgoalOneData(v.goal_id);
      this.getgoalFinishStatusData(v.goal_id);
      this.getgoalFinishRateData(v.goal_id);
    },
    handleCreateClick() {
      this.showSliderBoxCreate = true;
      // 清空数据
      (this.form = {
        goal_name: "",
        goal_starttime: "",
        goal_endtime: "",
        goal_mintrack: "",
        goal_normtrack: "",
        goal_norminvite: "",
        goal_mininvite: "",
        goal_normofficial: "",
        goal_minofficial: "",
        checkMarketer: [],
      }),
        this.getgoalCheckMarketerData();
    },
    handleClose(done) {
      this.$confirm(this.$t("Goalmanage.ba"))
        .then((_) => {
          (() => {})(_);
          done();
        })
        .catch((_) => {
          (() => {})(_);
        });
    },
    handleSizeChange(val) {
      (() => {})(`每页 ${val} 条`);
      this.pagesize = val;
      this.getSellgoalData(this.pagenum);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getSellgoalData(val);
      (() => {})(`当前页: ${val}`);
    },
    // 导出操作
    daochu() {
      let params_str = "",
        is_export = 1;
      for (name in this.selectForm) {
        if (name != "rang_time") {
          // 时间范围不需要
          params_str = params_str + `&${name}=${this.selectForm[name]}`;
        }
      }
      let url = storeGoalmanage.getSellgoal1();
      params_str = `${url}?marketer_id=${this.marketer_id}&token=${this.token}&school_id=${this.school_id}&company_id=${this.company_id}&re_postbe_id=${this.re_postbe_id}&postbe_crmuserlevel=${this.postbe_crmuserlevel}&language_type=${this.language_type}&is_export=${is_export}${params_str}`;
      (() => {})(params_str);
      if (this.tableData.length > 0) {
        window.open(this.$buildExportUrl(params_str), "_blank");
      } else {
        this.$message.error(this.$t("Common.exportTips"));
      }
    },
  },
};
</script>
<style lang="less">
@import url("../../assets/less/manage.less");
@import url("goalManage.less");
.goalManage {
  height: 100vh;
  font-size: 20px;
}
</style>
